import React from 'react';
import { Main } from './components';

const Wallet = () => <Main />;

export default Wallet;
